


























































import {namespace} from 'vuex-class';
import {mixins} from 'vue-class-component';
import {Component, Prop} from 'vue-property-decorator';
import GeneralUtil from '@/util/GeneralUtil';
import {User, MemberInfo} from '@/models';

const Auth = namespace('Auth');

@Component
export default class AgreeCompleteJoin extends mixins(GeneralUtil) {
  @Prop({type: Boolean, default: false}) agreePrivacy!: boolean;
  @Prop({type: Boolean, default: false}) marketingYn!: boolean;
  @Prop({type: Boolean, default: false}) agreeConsignment!: boolean;
  @Prop({type: String, default: ''}) guestName!: string;
  @Prop({type: String, default: ''}) guestNo!: string;
  @Prop({type: String, default: ''}) smsSendYn!: string;

  yesOrNo(param: string): string {
    if (param === 'Y') return '동의';
    else return '미동의';
  }
}
